import { Adder } from './Adder/Adder';
import { Condition } from './Condition/Condition';
import { Delay } from './Delay/Delay';
import { Dialogue } from './Dialogue/Dialogue';
import { Tag } from './Tag/Tag';
import { withMenu } from './elements/NodeMenu/WithMenu';
import { withReviewBadge } from './elements/ReviewBadge/ReviewBadge';
import { GoogleSheet } from './GoogleSheet/GoogleSheet';
import { JSONWebhook } from './JSONWebhook/JSONWebhook';
import { MailChimp } from './MailChimp/MailChimp';
import { Scheduler } from './Scheduler/Scheduler';
import { UnicornDetector } from './UnicornDetector/UnicornDetector';
import { Zapier } from './Zapier/Zapier';
import { FacebookAds } from './FacebookAds/FacebookAds';

export const nodeTypes = {
  adder: Adder,
  condition: withReviewBadge(withMenu(Condition)),
  scheduler: Scheduler,
  delay: withMenu(Delay),
  tag: withMenu(Tag),
  dialogue: withMenu(Dialogue),
  unicornDetector: withReviewBadge(withMenu(UnicornDetector)),
  zapier: withReviewBadge(withMenu(Zapier)),
  json_webhook: withReviewBadge(withMenu(JSONWebhook)),
  mailchimp: withReviewBadge(withMenu(MailChimp)),
  google_sheet: withReviewBadge(withMenu(GoogleSheet)),
  facebook_ads_audience: withReviewBadge(withMenu(FacebookAds)),
};

export enum NodeTypes {
  ADDER = 'adder',
  CONDITION = 'condition',
  SCHEDULER = 'scheduler',
  DELAY = 'delay',
  DIALOGUE = 'dialogue',
  UNICORN_DETECTOR = 'unicornDetector',
  ZAPIER = 'zapier',
  TAG = 'tag',
  JSON_WEBHOOK = 'json_webhook',
  MAILCHIMP = 'mailchimp',
  GOOGLE_SHEET = 'google_sheet',
  FACEBOOK_ADS = 'facebook_ads_audience',
}

export const getNode = (type?: NodeTypes) => {
  switch (type) {
    case NodeTypes.CONDITION:
      return Condition;
    case NodeTypes.DELAY:
      return Delay;
    case NodeTypes.DIALOGUE:
      return Dialogue;
    case NodeTypes.TAG:
      return Tag;
    case NodeTypes.SCHEDULER:
      return Scheduler;
    case NodeTypes.UNICORN_DETECTOR:
      return UnicornDetector;
    case NodeTypes.ZAPIER:
      return Zapier;
    case NodeTypes.JSON_WEBHOOK:
      return JSONWebhook;
    case NodeTypes.MAILCHIMP:
      return MailChimp;
    case NodeTypes.FACEBOOK_ADS:
      return FacebookAds;
    case NodeTypes.GOOGLE_SHEET:
      return GoogleSheet;
  }
};
